var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { ref: "panelGroup", staticClass: "cf-node-properties__panel-group row" },
    [
      _c("GenericProps", {
        attrs: {
          "node-id": _vm.node.id,
          settings: _vm.settings,
          parameters: _vm.node.parameters
        },
        on: {
          "update:settings": [
            function($event) {
              _vm.settings = $event
            },
            _vm.updateNodeParent
          ]
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "cf-node-properties__field col-md-12" },
        [
          _c("legend", { staticClass: "cf-node-properties__legend" }, [
            _c("span", {
              directives: [
                {
                  name: "t",
                  rawName: "v-t",
                  value: "ROUTER_ROUTES",
                  expression: "'ROUTER_ROUTES'"
                }
              ]
            })
          ]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-success btn-sm m-b-10",
              attrs: {
                type: "button",
                disabled: _vm.orderedRoutesList.length >= 10
              },
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  $event.preventDefault()
                  return _vm.addRoute.apply(null, arguments)
                }
              }
            },
            [
              _c("i", { staticClass: "fa fa-plus" }),
              _vm._v(" "),
              _c("span", {
                directives: [
                  {
                    name: "t",
                    rawName: "v-t",
                    value: "ROUTER_ADD_ROUTE",
                    expression: "'ROUTER_ADD_ROUTE'"
                  }
                ]
              })
            ]
          ),
          _vm._v(" "),
          _vm.orderedRoutesList.length == 0
            ? _c("div", { staticClass: "text-center" }, [
                _c("span", {
                  directives: [
                    {
                      name: "t",
                      rawName: "v-t",
                      value: "ROUTER_NO_ROUTES",
                      expression: "'ROUTER_NO_ROUTES'"
                    }
                  ]
                })
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.orderedRoutesList, function(route, index) {
            return _c(
              "RoutePanel",
              {
                key: route.id,
                attrs: {
                  index: index + 1,
                  route: route,
                  "open-options": true,
                  "focus-element": _vm.focusElement(route),
                  "weight-sum": _vm.weightSum
                },
                on: {
                  "update:route": function($event) {
                    route = $event
                  }
                }
              },
              [
                _c("SplitTestSetting", {
                  attrs: { route: route },
                  on: {
                    "update:route": function($event) {
                      route = $event
                    },
                    "route-change": _vm.onRouteChange
                  }
                })
              ],
              1
            )
          })
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }